const state = {
  contacts: []
};

export default state;
